export type AiReferral = {
  ai_provider: string;
  attribution_method: "utm_source" | "referrer";
  landing_path: string;
};

export function classifyAiReferral(
  landingUrl: string,
  referrer: string,
): AiReferral | null {
  let landing: URL;
  try {
    landing = new URL(landingUrl);
  } catch {
    return null;
  }
  const providers: Record<string, string> = {
    "chatgpt.com": "ChatGPT",
    "chat.openai.com": "ChatGPT",
    "perplexity.ai": "Perplexity",
    "claude.ai": "Claude",
    "gemini.google.com": "Gemini",
    "copilot.microsoft.com": "Copilot",
  };
  const aliases: Record<string, string> = {
    chatgpt: "ChatGPT",
    perplexity: "Perplexity",
    claude: "Claude",
    gemini: "Gemini",
    copilot: "Copilot",
  };
  const source = (landing.searchParams.get("utm_source") || "")
    .toLowerCase()
    .trim()
    .replace(/^www\./, "");
  if (providers[source] || aliases[source])
    return {
      ai_provider: providers[source] || aliases[source],
      attribution_method: "utm_source",
      landing_path: landing.pathname,
    };
  try {
    const host = new URL(referrer).hostname.toLowerCase().replace(/^www\./, "");
    for (const [domain, provider] of Object.entries(providers))
      if (host === domain || host.endsWith(`.${domain}`))
        return {
          ai_provider: provider,
          attribution_method: "referrer",
          landing_path: landing.pathname,
        };
  } catch {
    /* A missing referrer stays unattributed. */
  }
  return null;
}

const recorded = new Set<string>();
export function claimAiReferral(
  destination: "ga4" | "posthog",
  provider: string,
): boolean {
  const key = `tmw-ai-referral:${destination}:${provider}`;
  if (recorded.has(key)) return false;
  try {
    if (sessionStorage.getItem(key)) return false;
    sessionStorage.setItem(key, "1");
  } catch {
    /* Local history is optional. */
  }
  recorded.add(key);
  return true;
}
